import { Body, cn } from '@growtherapy/sprout-ui';

import { TrackingEvents, sendLoggingEvents } from '../../events';
import { useTheme } from '../../hooks';
import { Theme } from '../../state';
import { type BackgroundImageType, type BackgroundSettings, BackgroundType } from '../../video-sdk';
import { BackgroundButton } from './BackgroundButton';

export function BackgroundThumbnailGrid({
  images,
  title,
  setBackgroundSettings,
  selectedBackground,
  selectedBackgroundIndex,
  backgroundsSelectionIsDisabled,
  isMirrored,
  hasBorder,
}: {
  images: BackgroundImageType[];
  title: string;
  setBackgroundSettings: (backgroundSettings: BackgroundSettings) => void;
  selectedBackground?: BackgroundType;
  selectedBackgroundIndex?: number;
  backgroundsSelectionIsDisabled?: boolean;
  isMirrored: boolean;
  hasBorder?: boolean;
}) {
  const { theme } = useTheme();
  const isDarkTheme = theme === Theme.DARK;
  return (
    <>
      <Body.Small
        emphasis
        className={cn('text-small font-medium pb-2', {
          'rebrand:text-text-inverse': isDarkTheme,
        })}
        as='h3'
      >
        {title}
      </Body.Small>
      <ul className='grid grid-cols-3 gap-4 pb-3'>
        {images.map((image) => {
          return (
            <li key={image.id} className='max-h-20'>
              <BackgroundButton
                isDisabled={backgroundsSelectionIsDisabled}
                isSelected={selectedBackground === BackgroundType.IMAGE && selectedBackgroundIndex === image.id}
                isMirrored={isMirrored}
                image={image.thumb}
                altText={image.name}
                color={image.className}
                hasBorder={hasBorder}
                onClick={() => {
                  sendLoggingEvents(TrackingEvents.ANY_VIRTUAL_BACKGROUND_USE);
                  setBackgroundSettings({
                    backgroundType: BackgroundType.IMAGE,
                    backgroundIndex: image.id,
                  });
                }}
              />
            </li>
          );
        })}
      </ul>
    </>
  );
}
